export const EDIT_MODE_ACCESS_ROLES_DEFAULT = ['Admin']
